import { File as FileData } from '@tran-monorepo/interfaces/files';
import { APPLICATION_SUBMISSION_VALID_FILE_STATUSES } from '@tran-monorepo/interfaces/applications';
import {
    requiredPptFileTypes,
    requiredXlsFileTypes
} from '../components/application-detail/application-attachments/application-attachments-upload.config';

export interface RequiredDocumentsCheckResult {
    readonly hasMinFiles: boolean;
    readonly hasPpt: boolean;
    readonly hasXls: boolean;
    readonly isComplete: boolean;
}

export function evaluateRequiredDocuments(
    files: ReadonlyArray<Pick<FileData, 'name' | 'status'>>
): RequiredDocumentsCheckResult {
    const validFiles = files.filter(file => APPLICATION_SUBMISSION_VALID_FILE_STATUSES.includes(file.status));
    const hasMinFiles = validFiles.length >= 2;
    const hasPpt = validFiles.some(file => requiredPptFileTypes.some(ext => file.name.toLowerCase().endsWith(ext)));
    const hasXls = validFiles.some(file => requiredXlsFileTypes.some(ext => file.name.toLowerCase().endsWith(ext)));

    return {
        hasMinFiles,
        hasPpt,
        hasXls,
        isComplete: hasMinFiles && hasPpt && hasXls
    };
}

export function hasRequiredDocuments(files: ReadonlyArray<Pick<FileData, 'name' | 'status'>>): boolean {
    return evaluateRequiredDocuments(files).isComplete;
}

export function hasRequiredSubjectAreas(
    subjectAreas: ReadonlyArray<unknown>,
    additionalSubjectAreas: ReadonlyArray<unknown>
): boolean {
    return subjectAreas.length > 0 || additionalSubjectAreas.length > 0;
}
